import ClipTray from "./clip-tray";

export default ClipTray;